export default "__VITE_ASSET__Cmd5b$Mb__"